export const getEnpsScoreLabel = (score) => {
	if (score < 0) {
		return "Needs Improvement";
	}
	if (score >= 0 && score < 30) {
		return "Good";
	}
	if (score >= 30 && score < 70) {
		return "Great";
	}
	if (score >= 70) {
		return "Excellent";
	}
};

// return max Y setting for the eNPS breakdown chart from largest percentage score.
export const getChartMaxY = (percentage) => {
	if (percentage > 50 && percentage < 75) {
		return 75;
	}
	if (percentage > 75) {
		return 100;
	}
	return 50;
};
